import { SceneGridEditor } from '@/pages/SceneGridEditor';

/** Narration scene grid — same UI and controls as `/stories/:storyId/edit`. */
export const NarrationSceneGridEditor = () => <SceneGridEditor editorMode="narration" />;

export default NarrationSceneGridEditor;
